import React from 'react';

const Pricing = ({ onOrderClick }) => {
  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-green-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Special Launch Offer
          </h2>
          <p className="text-xl text-gray-600">
            Get your kit now at an unbeatable price
          </p>
        </div>

        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden border-4 border-green-500">
          <div className="bg-gradient-to-r from-green-500 to-green-600 text-white py-4 px-6 text-center">
            <p className="font-bold text-lg">🔥 LIMITED TIME OFFER - ONLY 23 KITS LEFT</p>
          </div>

          <div className="p-8">
            <div className="text-center mb-8">
              <p className="text-gray-500 text-lg mb-2">Regular Price:</p>
              <p className="text-3xl text-gray-400 line-through mb-4">₹7,999</p>
              <p className="text-gray-700 text-xl mb-2">Special Launch Price:</p>
              <div className="flex items-center justify-center gap-4">
                <p className="text-6xl font-bold text-green-600">₹1,999</p>
                <div className="bg-green-500 text-white px-4 py-2 rounded-lg">
                  <p className="font-bold">SAVE 75%</p>
                </div>
              </div>
              <p className="text-red-600 font-semibold mt-4 text-lg">
                ⚠️ Price increases to ₹3,999 tomorrow!
              </p>
            </div>

            <div className="bg-gray-50 rounded-xl p-6 mb-8">
              <h3 className="font-bold text-lg mb-4 text-center">What You Get:</h3>
              <div className="space-y-3">
                <div className="flex items-center gap-3">
                  <span className="text-green-500 text-xl">✓</span>
                  <span className="text-gray-700">Premium Acrylic QR Stand (4"x6")</span>
                </div>
                <div className="flex items-center gap-3">
                  <span className="text-green-500 text-xl">✓</span>
                  <span className="text-gray-700">High-Quality Laminated Vinyl Stickers Pack</span>
                </div>
                <div className="flex items-center gap-3">
                  <span className="text-green-500 text-xl">✓</span>
                  <span className="text-gray-700">Custom QR Code Setup</span>
                </div>
                <div className="flex items-center gap-3">
                  <span className="text-green-500 text-xl">✓</span>
                  <span className="text-gray-700">30-Day Money-Back Guarantee</span>
                </div>
                <div className="flex items-center gap-3">
                  <span className="text-green-500 text-xl">✓</span>
                  <span className="text-gray-700">24/7 Customer Support</span>
                </div>
                <div className="flex items-center gap-3">
                  <span className="text-green-500 text-xl">✓</span>
                  <span className="text-gray-700">Free Setup Guide & Video Tutorials</span>
                </div>
                <div className="flex items-center gap-3">
                  <span className="text-green-500 text-xl">✓</span>
                  <span className="text-gray-700">Lifetime Updates (No Subscription)</span>
                </div>
              </div>
            </div>

            <button
              onClick={onOrderClick}
              className="w-full bg-gradient-to-r from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 text-white py-5 rounded-xl font-bold text-xl transition-all transform hover:scale-105 shadow-lg"
              data-testid="pricing-order-button"
            >
              🚀 ORDER NOW - SAVE ₹6,000
            </button>

            <div className="mt-6 flex items-center justify-center gap-6 text-sm text-gray-600">
              <div className="flex items-center gap-2">
                <span className="text-green-500">🔒</span>
                <span>Secure Payment</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-green-500">🚚</span>
                <span>Fast Delivery</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-green-500">✅</span>
                <span>Zero Risk</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 bg-yellow-50 border-2 border-yellow-300 rounded-xl p-6">
          <h3 className="font-bold text-lg text-center mb-4 text-yellow-800">🛡️ 30-Day Money-Back Guarantee</h3>
          <p className="text-center text-gray-700">
            Try MPillar AIQR Kit risk-free for 30 days. If you're not satisfied with the results, 
            we'll refund your money - no questions asked. We're that confident you'll love it!
          </p>
        </div>
      </div>
    </section>
  );
};

export default Pricing;